import { NativeInterface } from './NativeInterface'

function queryString (search) {
  const query = {}
  if (search) {
    const params = search.substring(1).split('&')
    params.forEach(item => {
      const kv = item.split('=')
      if (kv[1]) {
        query[kv[0]] = decodeURIComponent(kv[1])
      }
    })
  }
  return query
}

function getEnv () {
  if (/(staging|localhost|127\.0\.0\.1|192\.168\.)/.test(window.location.href)) {
    return 'staging'
  } else {
    return 'production'
  }
}

const WX_SHARE_REGISTER = getEnv() !== 'production' ? 'https://telis.llsstaging.com/' : 'https://apitelis.llsapp.com'
const DEFAULT_API_LIST = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareWeibo', 'onMenuShareQZone']
const DEFAULT_CHANNEL_LIST_MAP = {
  onMenuShareTimeline: 'wx_timeline',
  onMenuShareAppMessage: 'wx_friend',
  onMenuShareWeibo: 'wb',
  onMenuShareQQ: 'qq',
  onMenuShareQZone: 'qz'
}
const params = queryString(location.search)

class WxShare {
  constructor () {
    this.apiList = DEFAULT_API_LIST
  }
  fetch (url, success) {
    const request = new XMLHttpRequest()
    request.open('GET', `${WX_SHARE_REGISTER}wxconfig?url=${encodeURIComponent(url)}`, true)
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        const data = JSON.parse(request.responseText)
        success(data)
      }
    }
    request.send()
  }
  register (url, apiList) {
    if (apiList) {
      this.apiList = apiList
    }
    if (window.wx) {
      this.fetch(url, (data) => {
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appid, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.noncestr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名，见附录1
          jsApiList: this.apiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      })
    }
  }
  ready (config) {
    window.wx.ready(() => {
      if ('shareTimeline' in config) {
        window.wx.onMenuShareTimeline(config.shareTimeline)
      }
      if ('shareAppMessage' in config) {
        window.wx.onMenuShareAppMessage(config.shareAppMessage)
      }
      if ('shareQQ' in config) {
        window.wx.onMenuShareQQ(config.shareQQ)
      }
      if ('shareQZone' in config) {
        window.wx.onMenuShareQZone(config.shareQZone)
      }
      if ('shareWeibo' in config) {
        window.wx.onMenuShareWeibo(config.shareWeibo)
      }
    })
  }
  _isInApp () {
    return !!params.appId
  }
  _isWeixin () {
    return /micromessenger/.test(window.navigator.userAgent.toLowerCase())
  }
  share (config) {
    if (this._isWeixin()) {
      this.wxShareRegister(config)
    } else if (this._isInApp()) {
      this.appWxShareRegister(config)
    } else {
      if (typeof config.success === 'function') {
        config.success()
      }
    }
  }
  wxShareRegister (config) {
    this.ready({
      shareTimeline: config,
      shareAppMessage: config,
      shareWeibo: config,
      shareQZone: config
    })
  }
  _getChannels () {
    const apiList = []
    this.apiList.forEach(item => {
      apiList.push(DEFAULT_CHANNEL_LIST_MAP[item])
    })
    return apiList
  }
  appWxShareRegister (config) {
    setTimeout(() => {
      if (typeof config.success === 'function') {
        config.success()
      }
    }, 3000)
    const shareConfig = {
      url: config.link,
      title: config.desc,
      content: config.title,
      channels: this._getChannels(),
      img: config.imgUrl
    }
    NativeInterface.invoke('share', JSON.stringify(shareConfig))
  }
}

export default {
  install (Vue, options = {}) {
    Vue.prototype.$wxShare = new WxShare(options)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/WxShare.js